import { render } from "./Certifications.vue?vue&type=template&id=2f309436&scoped=true"
import script from "./Certifications.vue?vue&type=script&lang=js"
export * from "./Certifications.vue?vue&type=script&lang=js"

import "./Certifications.vue?vue&type=style&index=0&id=2f309436&lang=postcss&scoped=true"

import exportComponent from "/github/workspace/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2f309436"]])

export default __exports__